/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Merge_DownInputs */



/**
* | output |
* | --- |
* | "Merge the selected Event with the next Event." |
*
* @param {Shortcut_Keys_Desc_Merge_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_merge_down = /** @type {((inputs?: Shortcut_Keys_Desc_Merge_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Merge_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner l'evenement selectionne avec l'evenement suivant.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das ausgewählte Ereignis wird mit dem nächsten Ereignis zusammengeführt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci l'evento selezionato con l'evento successivo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединить выбранное событие со следующим событием.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar el evento seleccionado con el siguiente evento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将选定的事件与下一个事件合并。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを次のイベントと結合します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट को अगले इवेंट के साथ मर्ज करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Combine o evento selecionado com o próximo evento.")
	return /** @type {LocalizedString} */ ("Merge the selected Event with the next Event.")
});